export const USER_ACTIONS = {
  INITIAL_PLAYLIST: "INITIAL_PLAYLIST",
  ADD_NEW_PLAYLIST: "ADD_NEW_PLAYLIST",
  DELETE_PLAYLIST: "DELETE_PLAYLIST",
  ADD_VIDEO_TO_PLAYLIST: "ADD_VIDEO_TO_PLAYLIST",
  REMOVE_VIDEO_FROM_PLAYLIST: "REMOVE_VIDEO_FROM_PLAYLIST",
  LIKED_VIDEOS_ACTIONS: "LIKED_VIDEOS_ACTIONS",
  INITIAL_LIKED_VIDEOS: "INITIAL_LIKED_VIDEOS",
  ADD_TO_LIKED_VIDEOS: "ADD_TO_LIKED_VIDEOS",
  REMOVE_FROM_LIKED_VIDEOS: "REMOVE_FROM_LIKED_VIDEOS",
  WATCH_LATER_ACTIONS: "WATCH_LATER_ACTIONS",
  HISTORY_ACTIONS: "HISTORY_ACTIONS",
};
